import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3da979e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-card-detail" }
const _hoisted_2 = { class: "m-nav-icons" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "m-card-img-wrap" }
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "m-card-info no-star"
}
const _hoisted_7 = { class: "m-card-img-wrap" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "guide-box",
  id: "guide-box"
}
const _hoisted_10 = {
  key: 0,
  class: "m-task-tab"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "u-tab-labels"
}
const _hoisted_13 = {
  key: 1,
  class: "m-task-title"
}
const _hoisted_14 = {
  key: 0,
  class: "m-task-tab"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "u-tab-labels"
}
const _hoisted_17 = {
  key: 1,
  class: "m-task-title"
}
const _hoisted_18 = { class: "m-task-list-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionBar = _resolveComponent("ActionBar")!
  const _component_loading_page = _resolveComponent("loading-page")!
  const _component_wrong_page = _resolveComponent("wrong-page")!
  const _component_task_progress = _resolveComponent("task-progress")!
  const _component_task_list = _resolveComponent("task-list")!
  const _component_sku_pop_mask = _resolveComponent("sku-pop-mask")!
  const _component_task_guide_pop = _resolveComponent("task-guide-pop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.showActionBar)
      ? (_openBlock(), _createBlock(_component_ActionBar, {
          key: 0,
          onGoBack: $setup.goBack,
          onGoShare: $setup.doShare,
          actionBarInfo: $setup.actionBarInfo,
          needShare: true
        }, null, 8, ["onGoBack", "onGoShare", "actionBarInfo"]))
      : _createCommentVNode("", true),
    ($setup.pageLoading && !$setup.showWrongPage)
      ? (_openBlock(), _createBlock(_component_loading_page, { key: 1 }))
      : _createCommentVNode("", true),
    ($setup.showWrongPage && !$setup.pageLoading)
      ? (_openBlock(), _createBlock(_component_wrong_page, {
          key: 2,
          showActionBar: $setup.showActionBar,
          onClickRefresh: $setup.clickRefresh
        }, null, 8, ["showActionBar", "onClickRefresh"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["m-card-detail-top", `m-card-detail-${$setup.cardType === 2 ? $setup.currentViewLevel : $setup.currentLevel > 0 ? 1 : 0}`]),
      ref: "refCardDetailWrap",
      style: _normalizeStyle({ opacity: $setup.boxOpacity })
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({ paddingTop: $setup.showActionBar ? $setup.actionBarHeight + 'px' : '0' })
      }, [
        ($setup.cardInfo.unionid && [$setup.cardInfo.card_type, $setup.cardType].includes(2))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["m-card-info", { paddingLess: $setup.showActionBar }])
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardInfo.card_imgs, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `icon-${index}-${$setup.currentViewLevel}`
                  }, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => ($setup.updateCurrentViewLevel(index)),
                      class: _normalizeClass(["u-card-nav-icon", {
                  active: index === 0 || index <= $setup.currentLevel,
                  'u-current': index === $setup.currentViewLevel
                }])
                    }, _toDisplayString(index), 11, _hoisted_3),
                    (index !== $setup.cardInfo.card_imgs.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["u-icon-separator", { active: index === 0 || index <= $setup.currentLevel }])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardInfo.card_imgs, (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: `image-${index}`,
                    class: "u-card-img",
                    src: item.star_img_url,
                    onClick: ($event: any) => ($setup.showCardInfo(item))
                  }, null, 8, _hoisted_5)), [
                    [_vShow, $setup.currentViewLevel === Number(item.star_num)]
                  ])
                }), 128)),
                ($setup.currentViewLevel > $setup.currentLevel)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "u-img-mask",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCardInfo()))
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : ($setup.cardInfo.unionid && ![$setup.cardInfo.card_type, $setup.cardType].includes(2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("img", {
                    class: "u-card-img",
                    src: $setup.cardInfo?.card_imgs?.[$setup.currentLevel > 0 ? 1 : 0]?.star_img_url,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCardInfo($setup.cardInfo?.card_imgs?.[$setup.currentLevel > 0 ? 1 : 0])))
                  }, null, 8, _hoisted_8), [
                    [_vShow, $setup.cardInfo?.card_imgs?.length]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
          [_vShow, $setup.gestureGuide]
        ])
      ], 4)
    ], 6), [
      [_vShow, !$setup.pageLoading && !$setup.showWrongPage && $setup.cardInfo.unionid]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "m-task-list",
      style: _normalizeStyle({ opacity: $setup.boxOpacity })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["m-task-tab-wrap m-task-tab-wrap-fixed", `m-task-list-${$setup.cardType == 2 ? $setup.currentViewLevel : $setup.currentLevel > 0 ? 1 : 0}`]),
        ref: "refTabWrapFixed",
        style: _normalizeStyle({ top: $setup.showActionBar ? `${$setup.actionBarHeight}px` : 0, display: $setup.displayTabWrapFixed })
      }, [
        ($setup.cardType === 2 && $setup.pTaskList && $setup.pTaskList.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pTaskList, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `tab-${index}`,
                  class: _normalizeClass(["u-tab-tile", { active: index === $setup.activeTab }]),
                  onClick: ($event: any) => ($setup.tabClick(index))
                }, [
                  _createTextVNode(_toDisplayString(`${index + 1}星任务`) + " ", 1),
                  (item?.labels?.[0]?.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item?.labels?.[0]?.name), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_11))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, "学习任务"))
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass(["m-task-tab-wrap", `m-task-list-${$setup.cardType == 2 ? $setup.currentViewLevel : $setup.currentLevel > 0 ? 1 : 0}`]),
        ref: "refTabWrap"
      }, [
        ($setup.cardType === 2 && $setup.pTaskList && $setup.pTaskList.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pTaskList, (item, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: `tab-${index}`,
                  class: _normalizeClass(["u-tab-tile", { active: index === $setup.activeTab }]),
                  onClick: ($event: any) => ($setup.tabClick(index))
                }, [
                  _createTextVNode(_toDisplayString(`${index + 1}星任务`) + " ", 1),
                  (item?.labels?.[0]?.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item?.labels?.[0]?.name), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_15))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, "学习任务"))
      ], 2),
      _createElementVNode("div", _hoisted_18, [
        (
            $setup.cardType !== 2 ||
            ($setup.cardType === 2 &&
              $setup.pTaskList?.[$setup.activeTab]?.publish_status &&
              $setup.pTaskList?.[$setup.activeTab]?.action !== 5)
          )
          ? (_openBlock(), _createBlock(_component_task_progress, {
              key: 0,
              progressData: $setup.progressData
            }, null, 8, ["progressData"]))
          : _createCommentVNode("", true),
        ($setup.cardInfo?.unionid)
          ? (_openBlock(), _createBlock(_component_task_list, {
              key: 1,
              reportDataMap: {
            ...$setup.reportDataMap,
            cardName: $setup.cardInfo?.card_name || $setup.cardName,
            card_name: $setup.cardInfo?.card_name || $setup.cardName
          },
              cardName: $setup.cardInfo?.card_name,
              cardType: $setup.cardType,
              skuId: $setup.skuId,
              unionid: $setup.unionid,
              parentInfo: $setup.pTaskList?.[$setup.activeTab] || {},
              difficulty: $setup.pTaskList?.[$setup.activeTab]?.difficulty || 0,
              taskList: $setup.taskList,
              onSetTheDoingTaskObj: $setup.setTheDoingTaskObj
            }, null, 8, ["reportDataMap", "cardName", "cardType", "skuId", "unionid", "parentInfo", "difficulty", "taskList", "onSetTheDoingTaskObj"]))
          : _createCommentVNode("", true)
      ])
    ], 4), [
      [_vShow, !$setup.pageLoading && !$setup.showWrongPage && $setup.taskList?.length]
    ]),
    ($setup.maskVisible)
      ? (_openBlock(), _createBlock(_component_sku_pop_mask, {
          key: 3,
          visible: $setup.maskVisible,
          versionName: $setup.versionName,
          cardInfo: $setup.cardPopInfo,
          reportDataMap: { ...$setup.reportDataMap, cardName: $setup.cardInfo?.card_name },
          type: $setup.popType,
          onDoClose: $setup.doClose,
          onDoSee: $setup.doClose,
          onDoShare: $setup.doShare
        }, null, 8, ["visible", "versionName", "cardInfo", "reportDataMap", "type", "onDoClose", "onDoSee", "onDoShare"]))
      : _createCommentVNode("", true),
    ($setup.taskGuideVisible)
      ? (_openBlock(), _createBlock(_component_task_guide_pop, {
          key: 4,
          visible: $setup.taskGuideVisible,
          cardInfo: $setup.cardPopInfo,
          popInfo: $setup.taskGuideInfo,
          reportDataMap: { ...$setup.reportDataMap, cardName: $setup.cardInfo?.card_name },
          onDoClose: $setup.doCloseGuide
        }, null, 8, ["visible", "cardInfo", "popInfo", "reportDataMap", "onDoClose"]))
      : _createCommentVNode("", true)
  ]))
}